import { memo } from 'react';
import { ActionIcon } from '@mantine/core';
import { IconMenu2, IconListDetails } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { FloatingPanel } from '@/components/ui/FloatingPanel';
import type { MobileSidebarToggleProps } from './FloatingNavBar.types';
import styles from './FloatingNavBar.module.css';

const TOGGLE_ICON_SIZE = 22;

export const MobileSidebarToggle = memo(function MobileSidebarToggle({
  onToggle,
  onToggleSidePanel,
}: MobileSidebarToggleProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.mobileSidebarToggle}>
      <FloatingPanel position="top-left" className={styles.elevated}>
        <div className={styles.mobileToggleContent}>
          <ActionIcon
            variant="subtle"
            size="lg"
            onClick={onToggle}
            aria-label={t('appShell.sidebar.toggleMenu')}
          >
            <IconMenu2 size={TOGGLE_ICON_SIZE} />
          </ActionIcon>
          <div className={styles.mobileToggleDivider} />
          <ActionIcon
            variant="subtle"
            color="gray"
            size="lg"
            onClick={onToggleSidePanel}
            aria-label={t('appShell.sidebar.togglePanel')}
          >
            <IconListDetails size={TOGGLE_ICON_SIZE} />
          </ActionIcon>
        </div>
      </FloatingPanel>
    </div>
  );
});
